<p-drawer
  [visible]="display"
  position="right"
  appendTo="body"
  (onHide)="onHide()">
  <div class="mb-2 left-sidebar clientdetails">
    <h1 class="mb-3" *ngIf="headingStatus">{{ createNewAddress }}</h1>
    <h1 class="mb-3" *ngIf="!headingStatus">{{ updateNewAddress }}</h1>
    <jni-address
      [parent]="clientForm"
      [formgroupName]="'addressInformation'"
      [cityList]="cityList"
      [countryRegionList]="countryRegionList"
      [countyList]="countyList"
      [districtList]="districtList"
      [stateList]="stateList"
      class="col-4 border-end"
      [hiddenHeadingStatus]="true"
      [isPrimaryFieldStatus]="isPrimaryFieldStatus"
      [countryRegionSelectedId]="countryRegionSelectedId"
      [isFromClient]="true"></jni-address>
    <!-- <button
      class="btn btn-primary me-3 post"
      type="submit"
      [disabled]="!clientForm.valid"
      (click)="onSubmit()">
      Save
    </button> -->
    <p-button
      label="Save"
      type="submit"
      (click)="onSubmit()"
      class="me-1 post" />
  </div>
</p-drawer>
